<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-12 17:12:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-27 16:14:27
-->
<script lang="ts" setup>
import { RangePicker } from 'ant-design-vue';
import { ref, useAttrs, watchEffect } from 'vue';
import type { RangePickerProps } from 'ant-design-vue/lib/date-picker';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { IRangePickerProps } from '../types';
import { dateTime } from '../../hooks/useFilter';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';

interface IProps extends IRangePickerProps {}

const props = defineProps<IProps>();

const emit = defineEmits(['update:value', 'change']);

const attrs: Partial<RangePickerProps> = useAttrs();

const mValue = ref<[start: Dayjs, end: Dayjs]>();

function change(date: [string, string] | [Dayjs, Dayjs]) {
  let value = null;
  if (date) {
    const [start, end] = date;
    value = [dayjs(start, attrs?.picker ?? 'date'), dayjs(end, attrs?.picker ?? 'date')];
  }

  emit('update:value', value);
  emit('change', value);
}

const { getBindValue } = useForm<IProps & RangePickerProps>({
  props,
  componentName: 'RangePicker',
  attrs: useAttrs(),
});

watchEffect(() => {
  if (getBindValue.value?.value) {
    const [start, end] = getBindValue.value.value;

    mValue.value = [dayjs(start, attrs?.picker ?? 'date'), dayjs(end, attrs?.picker ?? 'date')];
  } else {
    mValue.value = undefined;
  }
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly || readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle"
    ><slot :name="readOnlySlot" :text="getBindValue.value"
      ><span v-if="getBindValue.value">
        <span>开始：{{ dateTime(getBindValue.value[0].toString(), getBindValue.format as string) }}</span
        ><span> 结束：{{ dateTime(getBindValue.value[1].toString(), getBindValue.format as string) }} </span>
      </span>
    </slot>
  </span>

  <RangePicker v-else v-bind="getBindValue as any" v-model:value="mValue" @change="change" />
</template>
